import { Checkbox, Form, Tooltip } from "antd";
import styled from "styled-components";

interface CheckboxFieldProps {
  name: string;
  label: string;
  disabled?: boolean;
  tooltip?: string;
  warning?: string;
}

// A single boolean setting bound to a form field (valuePropName "checked"), with an optional
// help tooltip and inline warning text. Reveal-gate side effects are driven by the form's
// onValuesChange in the modal, so no per-checkbox onChange is needed here (which would fight
// antd's Form.Item onChange injection).
const CheckboxField = ({ name, label, disabled, tooltip, warning }: CheckboxFieldProps) => (
  <Form.Item name={name} valuePropName="checked" style={{ marginBottom: 8 }}>
    <Checkbox id={`dp-${name}`} disabled={disabled}>
      {label}
      {tooltip && (
        <Tooltip title={tooltip}>
          <HelpHint> (?)</HelpHint>
        </Tooltip>
      )}
      {warning && <WarningText> ({warning})</WarningText>}
    </Checkbox>
  </Form.Item>
);

export default CheckboxField;

const HelpHint = styled.span`
  color: var(--color-neutral__placeholder);
  cursor: help;
`;

const WarningText = styled.span`
  color: var(--color-error__regular);
`;
